import CardSkeleton from "@/components/Skeleton/CardSkeleton";
import ObjectHeaderSkeleton from "@/components/Skeleton/ObjectHeaderSkeleton";
import SectionHeadingSkeleton from "@/components/Skeleton/SectionHeadingSkeleton";
import TableSkeleton from "@/components/Skeleton/TableSkeleton";

export default function BillingObjectDetailsSkeleton() {
  return (
    <div data-testid="billing-object-details-skeleton">
      <ObjectHeaderSkeleton />
      <SectionHeadingSkeleton />
      <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        <CardSkeleton width={100} />
        <CardSkeleton width={100} />
        <CardSkeleton width={100} />
      </div>
      <TableSkeleton columns={4} rows={4} />
    </div>
  );
}
